/**
 * This file is created manually
 * You can change the content
 *
 */

import H5 from './typography/H5'
export * from './typography/H5'
export default H5
